export default {
  all: 'Tous',
}
